import { KOT_STATUS, KOT_STATUS_LABEL } from "Components/Constants/KotStatus";
import { COLOR_CODES } from "utils/colorCodes";

export const getKotStatus = (invoiceStatusCode) => {
  let kotStatus = "";

  if (invoiceStatusCode === KOT_STATUS.KOT_CREATE) {
    kotStatus = KOT_STATUS_LABEL.ACTIVE;
  } else if (invoiceStatusCode === KOT_STATUS.KOT_COMPLETE) {
    kotStatus = KOT_STATUS_LABEL.COMPLETE;
  } else if (invoiceStatusCode === KOT_STATUS.KOT_PROCESSING) {
    kotStatus = KOT_STATUS_LABEL.PROCESSING;
  } else if (invoiceStatusCode === KOT_STATUS.KOT_CREATED_BY_INVOICE) {
    kotStatus = KOT_STATUS_LABEL.CREATED_BY_INVOICE;
  } else if (invoiceStatusCode === KOT_STATUS.KOT_COMPLETE_WITH_INVOICE) {
    kotStatus = KOT_STATUS_LABEL.INVOICED;
  } else if (invoiceStatusCode === KOT_STATUS.INVOICE_PARTIAL) {
    kotStatus = KOT_STATUS_LABEL.PARTIAL_INVOICED;
  } else if (invoiceStatusCode === KOT_STATUS.KOT_REVERSED) {
    kotStatus = KOT_STATUS_LABEL.REVERSED;
  }

  return kotStatus;
};

export const getKotStatusBgColor = (invoiceStatusCode) => {
  let bgColor = "";

  if (invoiceStatusCode === KOT_STATUS.KOT_CREATE) {
    bgColor = COLOR_CODES.LOGO_BLUE;
  } else if (invoiceStatusCode === KOT_STATUS.KOT_COMPLETE) {
    bgColor = COLOR_CODES.BLACK;
  } else if (invoiceStatusCode === KOT_STATUS.KOT_PROCESSING) {
    bgColor = COLOR_CODES.LOGO_AQUA;
  } else if (invoiceStatusCode === KOT_STATUS.KOT_CREATED_BY_INVOICE) {
    bgColor = COLOR_CODES.GREEN;
  } else if (invoiceStatusCode === KOT_STATUS.KOT_COMPLETE_WITH_INVOICE) {
    bgColor = COLOR_CODES.GREEN;
  } else if (invoiceStatusCode === KOT_STATUS.INVOICE_PARTIAL) {
    bgColor = COLOR_CODES.DARK_YELLOW;
  } else if (invoiceStatusCode === KOT_STATUS.KOT_REVERSED) {
    bgColor = COLOR_CODES.RED;
  }

  return bgColor;
};
